import { useCallback, useMemo } from "react"

import createStore from "@Stores/base-factories"
import { hookOrganizationList, hookSiteList } from "@Stores/base-factories/store-list"

const useTwoFactorAuthenticationFactory = ({ fetch, collection: { reset, fetchById } }) => {
  const createAuthentication = useCallback(async ({ userId, method }) => await fetch({
    method: 'POST',
    url: `/two-factor-authentication/${userId}`,
    params: { method },
  }), [fetch])

  const validateAuthentication = useCallback(async ({ userId, confirmation }) => {
    const result = await fetch({
      method: 'PUT',
      url: `/two-factor-authentication/${userId}`,
      params: { confirmation },
    })
    if (result) {
      reset()
      await fetchById(userId)
    }

    return result
  }, [fetch, reset, fetchById])

  const disableAuthentication = useCallback(async (id, userId) => {
    await fetch({
      method: 'DELETE',
      url: `/two-factor-authentication/${id}`,
    })
    reset()
    userId && await fetchById(userId)
  }, [fetch, reset, fetchById])

  return useMemo(() => ({
    createAuthentication, validateAuthentication, disableAuthentication,
  }), [createAuthentication, validateAuthentication, disableAuthentication])
}

const { Provider, useStore } = createStore()
  .extendHookCollectionFactory('user')
  .extendHookCollectionsFactory('users')
  .extend(hookSiteList())
  .extend(hookOrganizationList())
  .extend(useTwoFactorAuthenticationFactory)
  .factory()

export {
  Provider as UserProvider,
  useStore as useUserStore,
  useTwoFactorAuthenticationFactory,
}
